<template>
  <div>
    <CardBase>
      <MacroSubHeader
        title="Prospectos"
        icon="fas fa-users fa-1x"
      >
        <template slot="actions">
          <!-- Filtros -->
          <el-button
            size="small"
            v-b-toggle.filter-collapse
            plain
            title="Mostrar/Ocultar Filtros"
          >
            <b-icon-filter /> 
            Filtros
            <b-badge v-if="hasActiveFilters" variant="primary" class="ml-1" pill>!</b-badge>
          </el-button>
  
          <!-- Exportar excel -->
          <el-button
            size="small" 
            plain
            :disabled="loading"
            @click="loadProspectos(true)"
          >
            <i class="el-icon-tickets"></i>
            Exportar prospectos
          </el-button>
  
          <!-- Consultar SPC -->
          <el-button
            size="small" 
            plain
            @click="navigateToSPC()"
          >
            <i class="el-icon-search"></i>
            Consultar SPC
          </el-button>
  
          <!-- Novo prospecto -->
          <el-button
            size="small" 
            type="primary"
            @click="navigateToProspectCreate()"
          >
            <i class="fa fa-plus"></i>
            Novo Prospecto
          </el-button>
        </template>
      </MacroSubHeader>
  
      <CardBase>
        <b-collapse id="filter-collapse" v-model="showFiltro" class="mb-3">
          <b-card body-class="shadow-sm">
            <b-form @submit.prevent="onSearch">
              <b-row>
                <b-col md="4">
                  <b-form-group label="Nome Empresa">
                    <b-form-input v-model="filters.empresa" />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="CNPJ">
                    <b-form-input
                      v-mask="['##.###.###/####-##']"
                      v-model="filters.cnpj"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="4">
                  <b-form-group label="Responsável">
                    <b-form-input v-model="filters.responsavel" />
                  </b-form-group>
                </b-col>
              </b-row>
  
              <b-row>
                <b-col md="3">
                  <b-form-group label="Código Distribuidor">
                    <b-form-input v-model="filters.codigo_distribuidor" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Consultor">
                    <b-form-input v-model="filters.consultor" />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Classe">
                    <b-form-select
                      v-model="filters.classe_distribuidor"
                      :options="classes"
                      :readonly="isCenter"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
  
              <b-row>
                <b-col md="3">
                  <b-form-group label="Inclusão De">
                    <date-picker
                      v-model="filters.fromDateCreated"
                      :config="datePickerConfig"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Inclusão Até">
                    <date-picker
                      v-model="filters.toDateCreated"
                      :config="datePickerConfig"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Aprovação De">
                    <date-picker
                      v-model="filters.fromDate"
                      :config="datePickerConfig"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group label="Aprovação Até">
                    <date-picker
                      id="ate"
                      v-model="filters.toDate"
                      :config="datePickerConfig"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
  
              <b-row align-v="end">
                <b-col md="4">
                  <b-form-group label="Indicado Por:">
                    <v-select
                      v-model="filters.indicanteSelecionado"
                      :options="listaDistribuidores"
                      @search="buscaDistribuidor"
                      placeholder="Código do Distribuidor"
                      v-mask="['#######']"
                    >
                      <div slot="no-options">Nenhum distribuidor encontrado</div>
                    </v-select>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-form-group>
                    <b-form-checkbox v-model="filters.hasIndicante">
                      Apenas Indicados
                    </b-form-checkbox>
                  </b-form-group>
                </b-col> 
                <!-- v-if="authorizedRoles(['adm', 'financeiro', 'cobranca'])" -->
                <b-col md="2">
                  <b-form-group>
                    <b-form-checkbox v-model="filters.cnaePendente">
                      Apenas Pendência de CNAE
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
  
            <template #footer>
              <b-row>
                <b-col class="text-right">
                  <b-button
                    variant="outline-secondary"
                    @click="clearFilters"
                    :disabled="loading"
                    class="mr-2"
                  >
                    <b-icon-x-circle /> Limpar Filtros
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="onSearch"
                    :disabled="loading"
                  >
                    <b-icon-search /> Buscar
                    <b-spinner v-if="loading" small />
                  </b-button>
                </b-col>
              </b-row>
            </template>
          </b-card>
        </b-collapse>
  
        <el-row class="mb-3">
          <el-col>
            <el-radio-group v-model="filters.status" size="mini" :disabled="loading">
                <el-radio-button 
                    v-for="(stat) in statusOptions"
                    :key="stat.text"
                    :label="stat.value"
                >
                    <div class="d-flex align-items-center">
                        <!-- <el-tag 
                            :type="stat.text == 'Todos' 
                                ? '' 
                                : (stat.text == 'Ativo' 
                                    ? 'success' 
                                    : (stat.text == 'Inativo' 
                                        ? 'warning' 
                                        : 'danger'
                                        )
                                    )"
                            size="mini" 
                            class="mr-1"
                        >
                            {{  filtro.status == stat.value ? filtro.total : 0  }}
                        </el-tag> -->
                        <span class="ml-1">{{ stat.text }}</span>
                    </div>
                </el-radio-button>
            </el-radio-group>
          </el-col>
        </el-row>
  
        <!-- Tabela -->
        <div>
          <div v-if="loading" class="border rounded p-3 d-flex align-items-center">
            <i class="el-icon-loading mr-2"></i>
            Carregando prospectos...
          </div>
  
          <!-- content -->                 
          <el-table
            v-else-if="!loading && prospectos.length > 0"
            class="rounded"
            empty-text="Nenhum prospecto encontrado." 
            v-loading="loading"
            :data="prospectos" 
            align="center" 
            border
            row-key="id"
            size="mini"
            :expand-row-keys="expandedRows"
            @expand-change="handleExpand"
          >     
            <!-- Expand -->
            <el-table-column type="expand">
                <div slot-scope="scope">
                    <div class="px-3">
                        <el-row :gutter="12">
                            <el-col :span="16">
                              <!-- content -->
                              <el-tabs type="border-card" v-model="activeTabName">
                                  <el-tab-pane name="first">
                                    <span slot="label">
                                      <i class="el-icon-folder"></i> 
                                      <span class="ml-1">Dados Adicionais</span>
                                    </span>
  
                                    <el-card>
                                      <el-descriptions title="Informações" :column="4" size="mini" :border="true">
                                          <template slot="extra">
                                            <div class="d-flex align-items-center">
                                                <el-button
                                                  size="mini" 
                                                  type="warning" 
                                                  plain 
                                                  title="Editar prospecto"
                                                  :style="{ width: '100%' }"
                                                  @click.native.prevent="navigateToProspectEdit(scope.row.id)"
                                                  :disabled="
                                                    loading &&
                                                    (
                                                      isGestor && 
                                                      ['AGUARDANDO', 'PRE-CADASTRO', 'ATIVO'].includes(scope.row.status)
                                                    )
                                                  "
                                                >
                                                  <i class="el-icon-edit"></i>
                                                  Editar Prospecto
                                                </el-button>
  
                                                <el-button
                                                  size="mini" 
                                                  type="primary" 
                                                  plain
                                                  :disabled="loading"
                                                  title="Ver prospecto"
                                                  @click.native.prevent="navigateToProspectShow(scope.row.id)"
                                                  :style="{ width: '100%' }"
                                                >
                                                  <i class="el-icon-right"></i>
                                                  Ver prospecto
                                                </el-button>
                                              </div> 
                                          </template>
                                          
                                          <!-- Prospecto -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Prospecto</template>
                                              <div class="d-flex align-items-center justify-content-between">
                                                  <span>{{ scope.row.prospecto_empresa.pessoa_juridica.nome_fantasia }}</span>
                                                  <div class="d-flex align-items-center">
                                                      <el-tag class="mr-2" type="info" size="mini">#{{ scope.row.id }}</el-tag>
                                                      <el-button size="mini" circle @click="copyThis(scope.row.id)">
                                                          <i class="el-icon-document-copy"></i>
                                                      </el-button>
                                                  </div>
                                              </div>
                                          </el-descriptions-item>
  
                                          <!-- Responsavel -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Responsável</template>
                                              <el-tag size="mini"> 
                                                {{
                                                  scope.row.prospecto_empresa &&
                                                  scope.row.prospecto_empresa.responsavel &&
                                                  scope.row.prospecto_empresa.responsavel.pessoa_fisica &&
                                                  scope.row.prospecto_empresa.responsavel.pessoa_fisica.nome || 'Responsável não cadastrado'
                                                }}
                                              </el-tag>
                                          </el-descriptions-item>
  
                                          <!-- Classe -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Classe</template>
                                              <el-tag size="mini">{{ scope.row.classe_distribuidor || '-' }}</el-tag>
                                          </el-descriptions-item>
                                          
                                          <!-- CNPJ -->
                                          <el-descriptions-item v-if="!scope.row.tipo_pessoa_fisica && scope.row.prospecto_empresa && scope.row.prospecto_empresa.pessoa_juridica" :span="2">
                                              <template slot="label">CNPJ</template>
                                              <div class="d-flex align-items-center justify-content-between">
                                                  {{
                                                    scope.row.prospecto_empresa &&
                                                    scope.row.prospecto_empresa.pessoa_juridica &&
                                                    scope.row.prospecto_empresa.pessoa_juridica.cnpj || '-'
                                                  }}
                                                  <el-button v-if="scope.row.prospecto_empresa.pessoa_juridica.cnpj" size="mini" circle @click="copyThis(scope.row.prospecto_empresa.pessoa_juridica.cnpj )">
                                                      <i class="el-icon-document-copy"></i>
                                                  </el-button>
                                              </div>
                                          </el-descriptions-item>
  
                                          <!-- CPF -->
                                          <el-descriptions-item v-else :span="2">
                                              <template slot="label">CPF</template>
                                              <div class="d-flex align-items-center justify-content-between">
                                                  {{ 
                                                    scope.row.prospecto_empresa &&
                                                    scope.row.prospecto_empresa.responsavel &&
                                                    scope.row.prospecto_empresa.responsavel.pessoa_fisica &&
                                                    scope.row.prospecto_empresa.responsavel.pessoa_fisica.cpf || '-'
                                                  }} 
                                                  <el-button v-if="scope.row.prospecto_empresa.responsavel.pessoa_fisica.cpf" size="mini" circle @click="copyThis(scope.row.prospecto_empresa.responsavel.pessoa_fisica.cpf)">
                                                      <i class="el-icon-document-copy"></i>
                                                  </el-button>
                                              </div>
                                          </el-descriptions-item>
  
                                          <!-- Cadastro tipo -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Cadastro tipo pessoa física?</template>
                                              <el-tag size="mini" :type="scope.row.tipo_pessoa_fisica ? 'primary' : 'info'">{{ scope.row.tipo_pessoa_fisica ? 'Sim' : 'Não'}}</el-tag>
                                          </el-descriptions-item>
  
                                          <!-- Cidade -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Cidade</template>
                                              <el-tag size="mini"> 
                                                {{
                                                  scope.row.prospecto_empresa &&
                                                  scope.row.prospecto_empresa.endereco &&
                                                  scope.row.prospecto_empresa.endereco.cidade &&
                                                  scope.row.prospecto_empresa.endereco.cidade.nome || '-'
                                                }}
                                                -
                                                {{
                                                  scope.row.prospecto_empresa &&
                                                  scope.row.prospecto_empresa.endereco &&
                                                  scope.row.prospecto_empresa.endereco.cidade &&
                                                  scope.row.prospecto_empresa.endereco.cidade.estado &&
                                                  scope.row.prospecto_empresa.endereco.cidade.estado.uf || '-'
                                                }}
                                              </el-tag>
                                          </el-descriptions-item>
  
                                          <!-- Criado em -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Criado em</template>
                                              <div class="d-flex align-items-center">
                                                <i class="el-icon-time"></i>
                                                <span class="ml-2">{{ formatDate(scope.row.created_at, 'DD/MM/YYYY') }}</span>
                                              </div>
                                          </el-descriptions-item>
  
                                          <!-- Digitado por -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Digitado por</template>
                                              <div class="d-flex align-items-center">
                                                <span>{{ scope.row.user.name }}</span>
                                              </div>
                                          </el-descriptions-item>
  
                                          <!-- Pendencia CNAE -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Pendência CNAE</template>
                                              <el-tag size="mini" :type="scope.row.cnae_pendente ? 'primary' : 'info'">{{ scope.row.cnae_pendente ? 'Sim' : 'Não'}}</el-tag>
                                          </el-descriptions-item>
  
                                          <!-- Possui pedido faturado? -->
                                          <el-descriptions-item :span="2">
                                              <template slot="label">Possui pedido faturado?</template>
                                              <el-tag size="mini" :type="scope.row.possui_pedido_faturado ? 'primary' : 'info'">{{ scope.row.possui_pedido_faturado ? 'Sim' : 'Não'}}</el-tag>
                                          </el-descriptions-item>
                                      </el-descriptions>
                                    </el-card>
                                  </el-tab-pane>
  
                                  <el-tab-pane name="second">
                                    <div slot="label">
                                      <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                        <i class="el-icon-chat-line-round"></i> 
                                        <div class="d-flex align-items-center" :style="{ gap: '12px' }">
                                          <span>Comentários</span>
                                          <el-tag v-if="scope.row.observacoes != undefined" size="small" type="warning">{{ scope.row.observacoes.length }}</el-tag>
                                        </div>
                                      </div>
                                    </div>
  
                                    <el-card>
                                      <div v-if="scope.row.observacoes.length > 0" style="max-height: 300px; overflow-y: auto;">
                                        <div
                                          v-for="value in scope.row.observacoes"
                                          :key="value.id"
                                          class="mb-2"
                                        >
                                          <b-card>
                                            <b-card-text>
                                              <p class="mb-1">
                                                <b>Comentário de:</b> {{ value.user.name }}
                                              </p>
                                              <p class="mb-1">
                                                <b>Data:</b> {{ value.created_at }}
                                              </p>
                                              <hr class="my-2" />
                                              <p class="mb-0">{{ value.observacao }}</p>
                                            </b-card-text>
                                          </b-card>
                                        </div>
                                      </div>
                                      <el-empty v-else description="Nenhum comentário para exibir"></el-empty>
                                    </el-card>
                                  </el-tab-pane>
                              </el-tabs>
  
                              <div class="d-flex align-items-center my-3 px-3" :style="{ gap: '12px' }">
                                <el-button
                                  v-if="(['DIGITADO', 'PENDENTE', 'INATIVO'].includes(scope.row.status)) && isAuthorized"
                                  type="success"
                                  plain
                                  size="small"
                                  @click.native.prevent="showModalAprovacaoFinanceira(scope.row.id)"
                                >
                                  <b-icon-check-circle /> 
                                  Enviar p/ Financeiro
                                </el-button>
  
                                <!-- && authorizedRoles(['adm', 'financeiro', 'cobranca']) -->
                                <el-button 
                                  v-if="scope.row.cnae_pendente"
                                  type="info"
                                  plain
                                  size="small"
                                  @click.native.prevent="limparPendenciaCnae(scope.row.id)"
                                >
                                  <b-icon-check2-circle /> 
                                  Limpar Pendência de CNAE
                                </el-button>
  
                                <!--  -->
                                <!-- && authorizedRoles(['adm', 'financeiro', 'cobranca']) -->
                                <el-button 
                                  v-if="scope.row.cnae_pendente"
                                  type="warning"
                                  plain
                                  size="small"
                                  @click.native.prevent="zerarLimiteCnae(scope.row.id)"
                                >
                                  <i class="el-icon-odometer"></i>
                                  Zerar Limite de Crédito
                                </el-button>
  
                                <el-button
                                  v-if="scope.row.status === 'INATIVO'"
                                  type="danger"
                                  plain
                                  size="small"
                                  :disabled="isGestor"
                                  @click.native.prevent="confirmaProspecto(scope.row.id)"
                                >
                                  <i class="el-icon-delete"></i>
                                  Excluir
                                </el-button>
                              </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-table-column>
  
            <!-- ID -->
            <el-table-column 
              label="Prospecto" 
              width="80"
              prop="id" 
              align="left"
            >
              <div slot-scope="scope">{{ scope.row.id }}</div>
            </el-table-column>
  
            <!-- Codigo vendedor -->
            <el-table-column 
              label="Código Vend." 
              width="120"
              prop="id" 
              align="left"
            >
              <div slot-scope="scope">{{ scope.row.codigo_vendedor }}</div>
            </el-table-column>
  
            <!-- Codigo Distr. -->
            <el-table-column 
              label="Código Distr." 
              width="120"
              prop="id" 
              align="left"
            >
              <div v-if="scope.row.distribuidor" slot-scope="scope">{{ scope.row.distribuidor.codigo }}</div>
              <el-tag 
                v-else
                type="info" 
                size="small"
              >
                Não associado
              </el-tag>
            </el-table-column>
  
            <!-- Nome -->
            <el-table-column 
              min-width="320" 
              label="Nome" 
              align="left"
            >
                <template slot-scope="scope">
                  <span 
                    v-if="scope.row.prospecto_empresa.pessoa_juridica.nome_fantasia"
                    class="text-truncate" 
                  >
                    {{ scope.row.prospecto_empresa.pessoa_juridica.nome_fantasia }}
                  </span>
                  <span v-else>Sem nome</span>
                </template>
            </el-table-column>
  
            <!-- Uf -->
            <el-table-column 
              label="UF" 
              width="60" 
              align="left"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.prospecto_empresa.endereco.cidade.estado.uf }}</span>
                </template>
            </el-table-column>
  
            <!-- Classe -->
            <el-table-column 
              label="Classe" 
              width="80" 
              align="center"
            >
                <template slot-scope="scope">
                  <el-tag size="small">{{ scope.row.classe_distribuidor }}</el-tag>
                </template>
            </el-table-column>
  
            <!-- Status -->
            <el-table-column 
              label="Status" 
              width="130" 
              align="left"
            >
                <template slot-scope="scope">
                    <el-tag
                        v-if="scope.row.status"
                        size="small"
                        :type="scope.row.status == 'ATIVO'
                            ? 'success' 
                            : (scope.row.status == 'DIGITADO' 
                              ? 'primary'
                              : (scope.row.status == 'PRE_CADASTRO' 
                                  ? 'info'
                                  : (scope.row.status == 'PENDENTE' 
                                    ? 'warning'
                                    : 'danger' 
                                  )
                                )
                              )"
                    >
                      {{ scope.row.status }}
                    </el-tag>
                </template>
            </el-table-column>
  
            <!-- Tipo Cadastro -->
            <el-table-column label="Tipo Cadastro" width="120" align="left">
                <template slot-scope="scope">
                    <el-tag
                      v-if="scope.row.tipo_cadastro"
                      size="small"
                      :type="scope.row.tipo_cadastro === 'NOVO' ? 'success' : 'primary'"
                    >
                      {{ scope.row.tipo_cadastro }}
                    </el-tag>
                </template>
            </el-table-column>
  
            <!-- Cadastrado por -->
            <el-table-column width="200" label="Cadastrado Por" align="left">
                <template slot-scope="scope">
                  <div class="text-truncate text-capitalize" v-if="scope.row.user">
                    {{ scope.row.user.name.toLowerCase() }}
                  </div>
  
                  <el-tag 
                    v-else
                    type="info" 
                    size="small"
                  >
                    Não Associado
                  </el-tag>
                </template>
            </el-table-column>
  
            <!-- Indicado por -->
            <el-table-column width="115" label="Indicado Por" align="left">
                <template slot-scope="scope">
                  <div v-if="scope.row.indicante">
                    {{ scope.row.indicante.codigo }}
                  </div>
  
                  <el-tag 
                    v-else
                    type="info" 
                    size="small"
                  >
                    Não Associado
                  </el-tag>
                </template>
            </el-table-column>
  
            <!-- Criado em -->
            <el-table-column label="Criado em" width="130" align="center">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-2">{{ formatDate(scope.row.created_at) }}</span>
                    </div>
                </template>
            </el-table-column>
  
            <!-- Aprovado em -->
            <el-table-column label="Aprovado em" width="150" align="center">
                <template slot-scope="scope">
                    <div v-if="scope.row.dt_aprova_financeiro" class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-2">{{ formatDate(scope.row.dt_aprova_financeiro) }}</span>
                    </div>
                    <el-tag 
                      v-else
                      type="warning" 
                      size="small"
                    >
                      Não Aprovado
                    </el-tag>
                </template>
            </el-table-column>
  
            <!-- Atualizado em -->
            <el-table-column label="Última atualização" width="140" align="center">
                <template slot-scope="scope">
                      <div class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-2">{{ formatDate(scope.row.updated_at) }}</span>
                    </div>
                </template>
            </el-table-column>
  
            <!-- Acoes -->
            <el-table-column 
              fixed="right"
              :width="50"
              align="right"
            >
              <div slot="header" style="width: 100%;">
                  <i class="el-icon-menu" />
              </div>
              <template slot-scope="scope">
                <div class="d-flex justify-content-between">
                  <el-popover placement="bottom-end" trigger="hover">
                    <el-button
                      slot="reference"
                      size="mini" 
                      type="info" 
                      plain 
                      circle
                      :disabled="loading"
                    >
                      <i class="el-icon-more"></i>
                    </el-button>
  
                    <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                      <div :style="{ width: '100%'}">
                        <el-button
                          size="mini" 
                          type="warning" 
                          plain 
                          title="Editar usuário"
                          :style="{ width: '100%' }"
                          @click.native.prevent="navigateToProspectEdit(scope.row.id)"
                          :disabled="
                            loading &&
                            (
                              isGestor && 
                              ['AGUARDANDO', 'PRE-CADASTRO', 'ATIVO'].includes(scope.row.status)
                            )
                          "
                        >
                          <i class="el-icon-edit"></i>
                          Editar Prospecto
                        </el-button>
                      </div>
  
                      <div :style="{ width: '100%'}">
                        <el-button
                          size="mini" 
                          type="primary" 
                          plain
                          :disabled="loading"
                          title="Ver prospecto"
                          @click.native.prevent="navigateToProspectShow(scope.row.id)"
                          :style="{ width: '100%' }"
                        >
                          <i class="el-icon-right"></i>
                          Ver prospecto
                        </el-button>
                      </div>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
          </el-table>
  
          <el-empty v-else description="Nenhum prospecto disponível"></el-empty>
        </div>
  
        <!-- Paginacao -->
        <el-row class="mt-3">
          <el-col>
              <el-pagination
                background
                :current-page.sync="currentPage"
                :page-sizes="[15, 50, 75, 100]"
                :page-size="perPage"
                layout="total, sizes, prev, pager, next"
                :total="totalRows"
                @current-change="loadProspectos()"
                @size-change="handleSizeChange"
              />
          </el-col>
        </el-row>
      </CardBase>
    </CardBase>

    <b-modal v-model="modalAprova" title="Confirmação de Envio" centered>
      <h4 class="text-info">
        Deseja realmente enviar para aprovação financeira?
      </h4>
      <template #modal-footer>
        <b-button variant="danger" @click="modalAprova = false">
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          @click="solicitarAprovacaoFinanceira"
          :disabled="loading"
        >
          <b-spinner v-if="loading" small />
          Sim, Enviar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  
  //Components
  import MacroSubHeader from "../_macro/MacroSubHeader.vue";
  import CardBase from "@/components/_macro/CardBase.vue";

  import moment from "moment";

  // Utils
  import { copyThis } from "@/util/copyThis.js";
  import { formatDate } from "@/util/formatters";

    // Components
    import 
    {
        Table,
        TableColumn,
        Message,
        Loading,
        Row,
        Col,
        Dialog,
        Button,
        Input,
        Switch,
        Option,
        Select,
        Pagination,
        Tag,
        Tooltip,
        Card,
        Empty,
        Notification,
        Skeleton,
        Form,
        FormItem,
        Tabs, 
        TabPane,
        RadioButton,
        RadioGroup,
        DatePicker,
        Dropdown,
        DropdownMenu, 
        DropdownItem,
        Popover,
        Badge
    } from "element-ui";

  export default {
    data() {
        return {
          loading: false,
          showFiltro: false,
          defaultFilters: {
          empresa: "",
          cnpj: "",
          responsavel: "",
          codigo_distribuidor: "",
          consultor: "",
          status: "TODOS",
          fromDateCreated: "",
          toDateCreated: "",
          fromDate: "",
          toDate: "",
          classe_distribuidor: null,
          hasIndicante: false,
          indicanteSelecionado: null,
          cnaePendente: false,
          },
          filters: {
          empresa: "",
          cnpj: "",
          responsavel: "",
          codigo_distribuidor: "",
          consultor: "",
          status: "TODOS",
          fromDateCreated: "",
          toDateCreated: "",
          fromDate: "",
          toDate: "",
          classe_distribuidor: null,
          hasIndicante: false,
          indicanteSelecionado: null,
          cnaePendente: false,
          },
          statusOptions: [
          { value: "TODOS", text: "Todos" },
          { value: "DIGITADO", text: "Digitado" },
          { value: "PRE-CADASTRO", text: "Pre-Cadastro" },
          { value: "AGUARDANDO", text: "Aguardando" },
          { value: "INATIVO", text: "Inativo" },
          { value: "ATIVO", text: "Ativo" },
          { value: "PENDENTE", text: "Pendente" },
          ],
          classes: [
          { value: null, text: "Selecione uma Classe" },
          { value: "A", text: "Classe A" },
          { value: "G", text: "Classe Gestora" },
          { value: "V", text: "Classe Varejo" },
          ],
          datePickerConfig: {
          format: "DD/MM/YYYY",
          showClose: true,
          },
          prospectos: [],
          enviarId: 0,
          deletarID: 0,
          totalRows: 0,
          currentPage: 1,
          perPage: 20,
          modalAprova: false,
          distribuidores: [],
          expandedRows: [],
          activeTabName: 'first',
        };
    },
    methods: {
        formatDateForAPI(dateString) {
            if (typeof dateString === "string" && dateString.includes("/")) {
            const m = moment(dateString, "DD/MM/YYYY");
            if (m.isValid()) {
                return m.format("YYYY-MM-DD");
            }
            }
            if (moment.isMoment(dateString) && dateString.isValid()) {
            return dateString.format("YYYY-MM-DD");
            }
            return ""; 
        },
        onSearch() {
            this.currentPage = 1;
            this.loadProspectos(false);
        },
        clearFilters() {
            this.filters = { ...this.defaultFilters };
            this.onSearch();
        },
        loadProspectos(excel = false) {
            this.loading = true;

            const params = {
                currentPage: this.currentPage,
                limit: this.perPage,
                hasIndicante: this.filters.hasIndicante,
                indicante: this.filters.indicanteSelecionado
                    ? this.filters.indicanteSelecionado.value
                    : "",
                from_created: this.formatDateForAPI(this.filters.fromDateCreated),
                to_created: this.formatDateForAPI(this.filters.toDateCreated),
                from: this.formatDateForAPI(this.filters.fromDate),
                to: this.formatDateForAPI(this.filters.toDate),
                empresa: this.filters.empresa,
                responsavel: this.filters.responsavel,
                cnpj: this.filters.cnpj,
                codigo_distribuidor: this.filters.codigo_distribuidor,
                consultor: this.filters.consultor,
                status: this.filters.status,
                classe_distribuidor: this.filters.classe_distribuidor,
                cnaePendente: this.filters.cnaePendente,
            };

            if(excel){ params['excel'] = excel }

            const config = {
                url: "/adm/prospecto/listar",
                method: "get",
                params: params,
            };

            if (excel) {
                axios.get('/adm/prospecto/listar', {params: params, responseType: 'blob'})
                    .then((response) => {
                    const blob = new Blob([response.data], {
                        type: response.headers["content-type"],
                    });
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `prospectos-${moment().format("YYYYMMDDHHmmss")}.xlsx`;
                    link.click();
                    window.URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                    console.error(error);
                    this.$bvToast.toast("Falha ao gerar o arquivo Excel.", {
                        title: "Erro",
                        variant: "danger",
                        solid: true,
                    });
                    })
                    .finally(() => {
                    this.loading = false;
                    });
            } else {
                axios.get('/adm/prospecto/listar', {params: params})
                    .then((response) => {
                    this.prospectos = response.data.data;
                    this.totalRows = response.data.total;
                    })
                    .catch((error) => {
                    console.error(error);
                    this.$bvToast.toast("Falha ao carregar prospectos.", {
                        title: "Erro",
                        variant: "danger",
                        solid: true,
                    });
                    })
                    .finally(() => {
                    this.loading = false;
                    });
            }
        },
        buscaDistribuidor(key) {
            if (key.length >= 4) {
            axios
                .get(`/adm/distribuidor/buscar/${key}`)
                .then((response) => {
                this.distribuidores = response.data;
                })
                .catch((error) => {
                console.log(error);
                });
            }
        },
        solicitarAprovacaoFinanceira() {
            this.loading = true;
            const data = { _method: "PUT" };

            axios
            .post(`/adm/prospecto/${this.enviarId}`, data)
            .then(() => {
                this.$bvToast.toast("Enviado para aprovação financeira!", {
                title: "Sucesso",
                variant: "success",
                solid: true,
                });
                this.modalAprova = false;
                this.loadProspectos(false);
            })
            .catch((error) => {
                console.log(error);
                const errors = error.response?.data?.errors;
                let message = "Falha ao Solicitar Aprovação Financeira";
                if (typeof errors === "object") message = errors.join("\n");
                else if (typeof errors === "string") message = errors;
                
                this.$bvToast.toast(message, {
                title: "Erro",
                variant: "danger",
                solid: true,
                });
            })
            .finally(() => {
                this.loading = false;
            });
        },
        confirmaProspecto(id) {
            this.deletarID = id;
            this.$bvModal
            .msgBoxConfirm("Realmente deseja deletar este prospecto?", {
                title: "Atenção",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: "Sim, Deletar",
                cancelTitle: "Cancelar",
                centered: true,
            })
            .then((value) => {
                if (value) {
                this.DeletaProspect();
                }
            })
            .catch((err) => {
                console.log("Erro no modal de confirmação", err);
            });
        },
        DeletaProspect() {
            this.loading = true;
            axios
            .get(`/adm/prospecto/deleta/${this.deletarID}`)
            .then(() => {
                this.$bvModal.msgBoxOk("Prospecto deletado com sucesso", {
                title: "Sucesso",
                buttonSize: "sm",
                centered: true,
                size: "sm",
                });
                this.loadProspectos(false);
            })
            .catch((error) => {
                console.log(error);
                this.$bvToast.toast("Falha ao deletar o prospecto.", {
                title: "Erro",
                variant: "danger",
                solid: true,
                });
            })
            .finally(() => {
                this.loading = false;
            });
        },
        showModalAprovacaoFinanceira(id) {
            this.modalAprova = true;
            this.enviarId = id;
        },
        limparPendenciaCnae(id) {
            this.$bvModal
            .msgBoxConfirm(
                "Os 3 CNAEs obrigatórios já constam na Receita Federal? Isso irá limpar a pendência de CNAE deste prospecto.",
                {
                title: "Limpar Pendência de CNAE",
                size: "sm",
                buttonSize: "sm",
                okVariant: "info",
                okTitle: "Sim, Limpar",
                cancelTitle: "Cancelar",
                centered: true,
                }
            )
            .then((value) => {
                if (value) {
                this.loading = true;
                axios
                    .post(`/adm/prospecto/${id}/limpar-cnae-pendente`)
                    .then(() => {
                    this.loadProspectos(false);
                    })
                    .catch((error) => {
                    console.log(error);
                    this.$bvToast.toast("Falha ao limpar a pendência de CNAE.", {
                        title: "Erro",
                        variant: "danger",
                        solid: true,
                    });
                    })
                    .finally(() => {
                    this.loading = false;
                    });
                }
            })
            .catch((err) => {
                console.log("Erro no modal de confirmação", err);
            });
        },
        zerarLimiteCnae(id) {
            this.$bvModal
            .msgBoxConfirm(
                "Os CNAEs continuam fora do padrão? Isso irá zerar o limite de crédito deste distribuidor.",
                {
                title: "Zerar Limite de Crédito",
                size: "sm",
                buttonSize: "sm",
                okVariant: "warning",
                okTitle: "Sim, Zerar Limite",
                cancelTitle: "Cancelar",
                centered: true,
                }
            )
            .then((value) => {
                if (value) {
                this.loading = true;
                axios
                    .post(`/adm/prospecto/${id}/zerar-limite-cnae`)
                    .then(() => {
                    this.loadProspectos(false);
                    })
                    .catch((error) => {
                    console.log(error);
                    this.$bvToast.toast("Falha ao zerar o limite de crédito.", {
                        title: "Erro",
                        variant: "danger",
                        solid: true,
                    });
                    })
                    .finally(() => {
                    this.loading = false;
                    });
                }
            })
            .catch((err) => {
                console.log("Erro no modal de confirmação", err);
            });
        },
        // Expande a linha da tabela e busca os dados do distribuidor
        handleExpand(row, expandedRows) {
            // Linha foi fechada
            if (!expandedRows.some(item => item.id === row.id)) {
                this.expandedRows = [];
                return;
            }

            // Mantém apenas esta linha aberta
            this.expandedRows = [row.id];
        },
        // Pagination
        handleSizeChange(val) {
            this.perPage = val
            this.loadProspectos();
        },
        navigateToSPC() {
            window.open('/adm/consultas-spc', '_blank');
        },
        navigateToProspectCreate() {
            window.location.assign('/adm/prospecto/create');
        },
        navigateToProspectEdit(prospect_id) {
            window.location.assign(`/adm/prospecto/${prospect_id}/edit`);
        },
        navigateToProspectShow(prospect_id) {
            window.location.assign(`/adm/prospecto/${prospect_id}`);
        },
        copyThis,
        formatDate,
    },
    computed: {
      listaDistribuidores() {
          if (!this.distribuidores || this.distribuidores.length === 0) return [];
          return this.distribuidores.map((el) => ({
              label: `${el.codigo} - ${el.nome}`,
              value: el.id,
          }));
      },
      hasActiveFilters() {
          return Object.keys(this.filters).some(key => {
          return this.filters[key] !== this.defaultFilters[key];
          });
      },
      isAuthorized() {
        return this.$store.getters['user/isAnyRole']([
          'adm', 'gestor', 'gestor_varejo', 'coord_comercial',
          'comercial', 'diretor_nacional', 'gerente_nacional',
          'gerente_regional', 'representante_varejo', 'coordenador_externo',
          'supervisor_externo', 'analista_farma'
        ]);
      },
      isGestor() {
        return this.$store.getters['user/isAnyRole'](['gestor']);
      },
      isCenter() {
          return this.$store.getters['user/isAnyRole'](['centro_distribuicao']);
      },
      // authorizedRoles(roles = []) {
      //    return this.$store.getters['user/isAnyRole'](roles);
      // }
    },
    watch: {
        "filters.status"(_newValue) {
          this.loadProspectos()
        }
    },
    mounted() {
        this.defaultFilters = { ...this.filters };
        this.loadProspectos();
    },
    components: {
      MacroSubHeader,
      CardBase,
      [Message.name]: Message,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Loading.name]: Loading,
      [Row.name]: Row,
      [Col.name]: Col,
      [Dialog.name]: Dialog,
      [Button.name]: Button,
      [Switch.name]: Switch,
      [Option.name]: Option,
      [Select.name]: Select,
      [Input.name]: Input,
      [Pagination.name]: Pagination,
      [Tooltip.name]: Tooltip,
      [Tag.name]: Tag,
      [Card.name]: Card,
      [Empty.name]: Empty,
      [Notification.name]: Notification,
      [Skeleton.name]: Skeleton,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [RadioButton.name]: RadioButton,
      [RadioGroup.name]: RadioGroup,
      [DatePicker.name]: DatePicker,
      [Dropdown.name]: Dropdown,
      [DropdownMenu.name]: DropdownMenu,
      [DropdownItem.name]: DropdownItem,
      [Popover.name]: Popover,
      [Badge.name]: Badge
    },
  }
</script>

<style scoped>
[v-b-toggle] {
  cursor: pointer;
}

::v-deep .row-clickable {
  cursor: pointer;
}

::v-deep .b-table-details .card {
  border: 0;
}
::v-deep .b-table-details .tab-content {
  background-color: #f8f9fa;
}

/* [NOVO] Adiciona estilo para o rodapé de ações dentro dos detalhes */
::v-deep .b-table-details .card-footer {
  background-color: #e9ecef; /* Um cinza um pouco mais escuro que o light */
}


::v-deep .v-select .vs__dropdown-toggle,
::v-deep .v-select .vs__search,
::v-deep .form-control[readonly] {
  background-color: #fff;
}

::v-deep .form-control.mx-input {
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/adm_prospecto/Index.vue